<template>
    <BootstrapDialog title="新增版本" ref="dialog" size="lg" @afterClose="afterClose()">

        <template v-slot:body>
            <div class="modal-body wrapper-lg" style="width:100%">
                <div class="row">
                    <div class="col-sm-8 col-sm-offset-2">

                        <form role="form">
                            <div class="form-group">
                                <label><span style="color: red">*</span>版本号</label>
                                <input type="text"  v-model="model.bbh" name="bbh" v-validate="{required:true,max:50}" data-vv-as="版本号" class="form-control" placeholder=""/>
                                <span class="error_validate_msg"><em>{{ errors.first('bbh') }}</em></span>
                            </div>

                            <div class="form-group">
                                <label><span style="color: red">*</span>设备类型</label>
                                <select name="lx" v-model="model.lx" class="form-control" data-vv-as="设备类型" v-validate="{required:true}">
                                    <option value="">-请选择-</option>
                                    <option value="android">android</option>
                                    <option value="ios">ios</option>
                                </select>
                                <span class="error_validate_msg"><em>{{ errors.first('lx') }}</em></span>
                            </div>

                            <div class="form-group" v-if="model.lx === 'android'">
                                <label><span style="color: red">*</span>下载地址</label>
                                <input type="text"  v-model="model.url" name="url" v-validate="{required:true}" data-vv-as="下载地址" class="form-control" placeholder=""/>
                                <span class="error_validate_msg"><em>{{ errors.first('url') }}</em></span>
                            </div>

                            <div class="form-group">
                                <label><span style="color: red">*</span>升级类型</label>
                                <select name="gxlx" v-model="model.gxlx" class="form-control" data-vv-as="升级类型" v-validate="{required:true}">
                                    <option value="">-请选择-</option>
                                    <option value="0">建议升级</option>
                                    <option value="1">强制升级</option>
                                </select>
                                <span class="error_validate_msg"><em>{{ errors.first('gxlx') }}</em></span>
                            </div>

                            <div class="form-group">
                                <label><span style="color: red">*</span>升级提示</label>
                                <input type="gxts"  v-model="model.gxts" name="gxts" v-validate="{required:true,max:50}" data-vv-as="升级提示" class="form-control" placeholder=""/>
                                <span class="error_validate_msg"><em>{{ errors.first('gxts') }}</em></span>
                            </div>

                        </form>

                    </div>
                </div>
            </div>
        </template>

        <template v-slot:footer>
            <button class="btn btn-primary" type="button" @click="save()">保存</button>
            <button style="margin-left:10px" class="btn btn-default" type="button" @click="close()">关闭</button>
        </template>

    </BootstrapDialog>
</template>
<script>

    /**
     * APP版本管理新增
     */
    export default {
        name:'appversionAdd',
        components:{
        },
        data:function(){
            return {
                model:{
                    // 版本号
                    bbh: '',
                    // 设备类型
                    lx: '',
                    // 下载地址
                    url: '',
                    // 升级类型
                    gxlx: '',
                    // 升级提示
                    gxts:''
                }
            }
        },

        methods:{
            reset:function(){
                this.model = {
                    // 版本号
                    bbh: '',
                    // 设备类型
                    lx: '',
                    // 下载地址
                    url: '',
                    // 升级类型
                    gxlx: '',
                    // 升级提示
                    gxts:''
                };
            },

            open:function(){
                this.$refs.dialog.open();
            },

            close:function(){
                this.$refs.dialog.close();
            },

            afterClose:function(){
                this.$validator.reset();
                this.reset();
            },

            save:function(){
                this.$validator.validateAll().then((result) => {
                    if (result) {//如果表单校验通过才可以保存
                        if (this.model.lx === 'ios') {
                            delete this.model.url
                        }
                        this.$http.post('/htgl/sys/app/bbgl/xz',this.model).then(res=>{
                            if(res.data==true){
                                this.$success('操作成功',()=>{
                                    this.close();
                                    this.$parent.search();//刷新列表
                                });
                            }
                        });
                    }
                });
            }
        }

    }
</script>
